import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
import { ModalService } from 'src/app/_services/modal.service';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { API_URL, RENEWALS_URL, SUBMISSION_URL } from 'src/app/_common/constants';
import { map } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { FileDownloadService } from 'src/app/_services/file-download.service';

@Injectable({
  providedIn: 'root'
})

export class RenewalsService {
  
  private _renewal;
  private _selectedStep: string; //Using it in HTML

  private supportingDocuments = [];
  private _expiringPoliciesData: any;
  private _renewalAccountData: any;

  constructor(private http: HttpClient, private commonService: CommonService, private modalService: ModalService, private fileDownloadService: FileDownloadService) { }

  set header(data){
    this.commonService.header = data;
  }
  
  get runningServices(){
    return this.commonService.runningServices;
  }
  
  
  openModal(modalType, modalName, isKeyboard = true, backdropClass: string = '', isBackdrop?: boolean | 'static', customWindowClass='', size ="", _centered=true) {
    if(modalType === 'error'){
      this.modalService.openErrorModal();
    } else {
      this.modalService.openModal(modalName, isKeyboard, backdropClass, isBackdrop, customWindowClass, size, _centered);
    }
  }

  closeModal() {
    this.modalService.closeModal();
  }

  hasOpenModals() {
    return this.modalService.hasOpenModals();
  }


  // Get the Renewal Data from storage.
  getRenewalData(){
    let psiData = this.commonService.getData();
    return psiData.renewal;
  }  

  // Store the Renewal Data to storage.
  storeRenewalData(_renewal){
    let psiData = this.commonService.getData();
    psiData.renewal = _renewal;
    this.commonService.storeData(psiData);
  }
  
  // Get the Renewal Account Data from storage.
  getRenewalAccountData(){
    let psiData = this.commonService.getData();
    return psiData.renewalAccount;
  }  

  // Store the Renewal Account Data to storage.
  storeRenewalAccountData(_renewal){
    let psiData = this.commonService.getData();
    psiData.renewalAccount = _renewal;
    this.commonService.storeData(psiData);
  }

  get renewalAccountData() {
    if(this._renewalAccountData){
      this._renewalAccountData = this.getRenewalAccountData();
    }

    return this._renewalAccountData;
  }

  set renewalAccountData(_renewalAccountData){
    this._renewalAccountData = _renewalAccountData;
    this.storeRenewalAccountData(_renewalAccountData);
  }
  
  get renewal(){
    if(!this._renewal){
      this._renewal= this.getRenewalData();
    }
    return this._renewal;
  }
  set renewal(_renewal){
    this._renewal = _renewal;
    this.storeRenewalData(_renewal);
  }

  get selectedStep():string{
    if(!this._renewal){
      this._renewal = this.getRenewalData();
    }
    return this._renewal.selectedStep;
  }
  set selectedStep(_step){
    this._renewal.selectedStep = _step;
    this._selectedStep = _step;
    this.storeRenewalData(this._renewal);
  }

  get bindRenewal(){
    if(!this._renewal){
      this._renewal= this.getRenewalBindData();
    }
    return this._renewal;
  }
  set bindRenewal(_renewal){
    this._renewal = _renewal;
    this.storeRenewalBindData(_renewal);
  }

  // Get the Renewal Data from storage.
  getRenewalBindData(){
    let psiData = this.commonService.getData();
    return psiData.renewalbind;
  }  

  // Store the Renewal Data to storage.
  storeRenewalBindData(_renewalbind){
    let psiData = this.commonService.getData();
    psiData.renewalbind = _renewalbind;
    this.commonService.storeData(psiData);
  }

  get selectedBindStep():string{
    if(!this._renewal){
      this._renewal = this.getRenewalBindData();
    }
    return this._renewal.selectedStep;
  }
  set selectedBindStep(_step){
    this._renewal.selectedStep = _step;
    this._selectedStep = _step;
    this.storeRenewalBindData(this._renewal);
  }

  addSupportingDocument(_document){
    this.supportingDocuments.push(_document);
  }
  getSupportingDocuments() {
    return this.supportingDocuments;
  }
  setSupportingDocuments(_documents){
    this.supportingDocuments = _documents;
  }

  getLoggedInProfile(){
    return this.commonService.getData().currentUser;
  }

  // Fetch all the accounts that has upcoming Renewals 
  fetchRenewals():Observable<HttpResponse<any>> {
    return this.http.get<any>(RENEWALS_URL.RenewalOverview, { observe: 'response' })
      .pipe(map(response => {
        return response.body.result;
      }));
  }

  //For Manage Renewal
  fetchRenewalDetails(_accountNumber, _renewalNumber):Observable<HttpResponse<any>> {
    return this.http.get<any>(RENEWALS_URL.ManageRenewal + _accountNumber + '/manage/' + _renewalNumber, { observe: 'response' })
      .pipe(map(response => {
        return response.body.result;
      }));
  }

  /* //Start Renewal basic data..
  startRenewal(criteria):Observable<HttpResponse<any>> {
    return this.http.post<any>(RENEWALS_URL.StartRenewal, criteria, { observe: 'response' })
      .pipe(map(response => {
        return response.body.result;
      }));
  } */

  //Common call for Start Renewal, Change Renewal and Bind
  initRenewalData(_type, _criteria):Observable<HttpResponse<any>> {
    return this.http.get<any>(RENEWALS_URL.ManageRenewal + _criteria.accountNumber + "/" + _type + "/"+ _criteria.renewalNumber, { observe: 'response' })
      .pipe(map(response => {
        return response.body.result;
      }));
  }

  //Fetch Renewal Lookup Data..
  fetchRenewalsLookupData():Observable<HttpResponse<any>> {
    return this.http.get<any>(RENEWALS_URL.LookupList, { observe: 'response' })
      .pipe(map(response => {
        return response.body.result;
      }));
  }
  
  submitRenewal(_finalRenewalData) {
    return this.http.post<any>(RENEWALS_URL.SubmitRenewal, _finalRenewalData, { observe: 'response' })
      .pipe(map(response => {
        return response.body.result;
      }))
  }

  //Get Details for Bind
  fetchBindDetails(_renewalNumber):Observable<HttpResponse<any>> {
    return this.http.get<any>(RENEWALS_URL.ManageRenewal + _renewalNumber + '/bind/', { observe: 'response' })
      .pipe(map(response => {
        return response.body.result;
    }));
  }

  submitBind(criteria):Observable<HttpResponse<any>> {
    return this.http.post<any>(RENEWALS_URL.Bind, criteria, { observe: 'response' })
      .pipe(map(response => {
        return response.body.result;
      }));
  }

  downloadLossRunReport(number: string, reportBy: string):any {
    return this.fileDownloadService.downloadLossRunReport(number, reportBy);
  }

  downloadDocuments(accountId, documentId, documentName="") {
    return this.fileDownloadService.downloadPolicyDocument(accountId, documentId, documentName);
  }

  /* //Change Renewal Request basic data..
  changeRenewalRequest(criteria):Observable<HttpResponse<any>> {
    return this.http.get<any>(RENEWALS_URL.ChangeRenewalRequest.replace("{renewalNumber}", criteria.renewalNumber), { observe: 'response' })
      .pipe(map(response => {
        return response.body.result;
      }));
  } */

  submitChangeRenewalRequest(_finalRenewalChangeData) {
    return this.http.post<any>(RENEWALS_URL.SubmitChangeRenewalRequest, _finalRenewalChangeData, { observe: 'response' })
      .pipe(map(response => {
        return response.body.result;
      }))
  }
}